import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Field, FieldGroup } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { getOrgRoleLabel, type OrgUser, type User } from '../../../../models/user'

export function UserTab({ user, orgUser }: { user: User; orgUser: OrgUser }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>User Details</CardTitle>
        <CardDescription>Your account information.</CardDescription>
      </CardHeader>
      <CardContent>
        <FieldGroup className="max-w-sm">
          <div className="grid grid-cols-2 gap-4">
            <Field>
              <Label>First Name</Label>
              <Input value={user.firstName || ''} disabled />
            </Field>
            <Field>
              <Label>Last Name</Label>
              <Input value={user.lastName || ''} disabled />
            </Field>
          </div>
          <Field>
            <Label>Email</Label>
            <Input value={user.email || ''} disabled />
          </Field>
          <Field>
            <Label>Phone</Label>
            <Input value={user.mobile || ''} disabled />
          </Field>
          <Field>
            <Label>Role</Label>
            <Input value={getOrgRoleLabel(orgUser?.role || '')} disabled />
          </Field>
        </FieldGroup>
      </CardContent>
    </Card>
  )
}
